import { TemplateService } from 'src/app/service/template.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politicas-privacidade',
  templateUrl: './politicas-privacidade.component.html',
  styleUrls: ['./politicas-privacidade.component.scss']
})
export class PoliticasPrivacidadeComponent implements OnInit {

  constructor(public template: TemplateService) { }

  ngOnInit(): void {
  }

}
